import { useEffect, useState } from "react";
import DocumentsDetails from "../Documents/DocumentsDetails";
import { ITechincalDocument } from "src/Utils/Hooks/Downloads/useGetTechicalDocuments";
import markeingMaterial from 'src/images/additional-marketing-material.png';
import { Config } from "src/Utils/ConfigService/LoadConfig";

const MarketingMaterialDocuments: React.FC = () => {
    const [data, setData] = useState<ITechincalDocument[]>();

    useEffect(() => {
        const marketing_data: ITechincalDocument = {
            displayName: 'Additional Marketing Material',
            previewData: markeingMaterial,
            sasToken: Config.GetConfigData().marketingMaterialUrl,
        }
        setData([marketing_data])
    }, [])
    return (
        <>
            {data &&
               <DocumentsDetails data={data} title="Marketing Material" id="marketing-material-doc" />
            }
        </>
    )
}
export default MarketingMaterialDocuments;